import { render, staticRenderFns } from "./FinStatistics.vue?vue&type=template&id=533ae30e&scoped=true&"
import script from "./FinStatistics.vue?vue&type=script&lang=js&"
export * from "./FinStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ae30e",
  null
  
)

export default component.exports